import React from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { InfinityList } from '../../';
import SessionRow from './sessionRow';

const VISIBLE_ITEM_COUNT = 3;
const ROW_HEIGHT = 320;
const ROW_HEIGHT_PAST = 240;

export const Mode = Object.freeze({
  Upcoming: 'upcoming',
  Past: 'past',
});

const SessionTable = ({
  mode,
  sessions,
  overallSessionCount,
  loading,
  onLoad,
  onSessionStartHandler,
  onEditHandler,
  onRemoveHandler,
  onFinishHandler,
  ...rest
}) => {
  const onRenderRow = ({ key, style, index }) => {
    const session = sessions[index];

    return (
      <div key={key} style={style}>
        <Box height="100%">
          <SessionRow
            session={session}
            mode={mode}
            onEditHandler={onEditHandler}
            onRemoveHandler={onRemoveHandler}
            onSessionStartHandler={onSessionStartHandler}
            onFinishHandler={onFinishHandler}
          />
        </Box>
      </div>
    );
  };

  return (
    <Box {...rest}>
      <InfinityList
        items={sessions}
        visibleItemCount={VISIBLE_ITEM_COUNT}
        itemOverallCount={overallSessionCount}
        loading={loading}
        onLoad={onLoad}
        rowHeight={mode === Mode.Upcoming ? ROW_HEIGHT : ROW_HEIGHT_PAST}
        onRenderRow={onRenderRow}
        loadThreshold={VISIBLE_ITEM_COUNT}
      />
    </Box>
  );
};

SessionTable.propTypes = {
  mode: PropTypes.string.isRequired,
  sessions: PropTypes.array.isRequired,
  overallSessionCount: PropTypes.number,
  loading: PropTypes.bool,
  onLoad: PropTypes.func,
  onEditHandler: PropTypes.func,
  onRemoveHandler: PropTypes.func,
  onSessionStartHandler: PropTypes.func,
  onFinishHandler: PropTypes.func,
};

SessionTable.defaultProps = {
  loading: false,
  onLoad: () => {},
  onEditHandler: () => {},
  onRemoveHandler: () => {},
  onSessionStartHandler: () => {},
  onFinishHandler: () => {},
};

export default SessionTable;
